import React from 'react';
import '@/components/layout/Footer.scss';
import { Link, useLocation } from 'react-router-dom';

const Footer: React.FC = () => {
  const locn = useLocation();
  const isFoundation = locn.pathname === '/ventures/ephemera-foundation';
  console.log(isFoundation);
  return (
    <footer className="footer">
      <div className="footer__main">
        <p>
          {isFoundation
            ? `© The Ephemera Foundation (Stichting Ephemera). An independent foundation established under the laws of the Netherlands. The Foundation does not offer or solicit investments and does not engage in commercial activities.`
            : `© ${new Date().getFullYear()} Ephemera Partners L.P. Private investment vehicle formed under the Delaware Revised Uniform Limited Partnership Act. Not an offer/solicitation.`}
        </p>
        <div className="footer__links">
          <Link className="footer__link" to="/legal">
            Legal
          </Link>
          {!isFoundation && (
            <Link className="footer__link" to="/terms">
              Terms
            </Link>
          )}
          <Link className="footer__link" to="/privacy">
            Privacy
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
